import { Button, Form } from 'antd'

import Breadcrumb from 'component/breadcrumb/breadcrumb'
import { BREADCRUMBS } from 'constants/breadcrumb'
import useCreatePTOV2 from 'hooks/pto-v2/use-create-pto-v2'
import BaseInformation from 'modules/pto-v2/form/base-information'
import CoTrustedPartners from 'modules/pto-v2/form/co-trusted-partners'
import MetadataNFT from 'modules/pto-v2/form/metadata-nft'
import Properties from 'modules/pto-v2/form/properties'
import RentalInformation from 'modules/pto-v2/form/rental-information'
import UploadFile from 'modules/pto-v2/form/upload-file'
import { notifyFormErrors } from 'utils/form-errors'

import './style.scss'

/**
 * PTO v2 create screen: no NFT Price / Transaction Fee / Timelines.
 * Those are set when listing for sale (Selling Details tab).
 */
const CreatePTOV2 = () => {
  const additionalItems = [BREADCRUMBS.PTO_V2, BREADCRUMBS.PTO_V2_CREATE_NO_LINK]
  const [form] = Form.useForm()

  const {
    thumbnail,
    setThumbnail,
    thumbnails,
    setThumbnails,
    propertyTypes,
    isSubmitting,
    handleSubmit,
    handleCancel,
  } = useCreatePTOV2({ form })

  console.log(
    'thumbnail',
    thumbnail.length === 0,
    thumbnails.length === 0,
    isSubmitting,
    form.getFieldsError().some(({ errors }) => errors.length > 0)
  )

  return (
    <div className="p2p-create">
      <Breadcrumb additionalItems={additionalItems} />
      <Form
        form={form}
        layout="vertical"
        initialValues={{ remember: true }}
        style={{ padding: '20px 10px' }}
        onFinish={handleSubmit}
        onFinishFailed={notifyFormErrors}
        scrollToFirstError={{
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        }}
      >
        <BaseInformation form={form} edit={true} mode="create" />

        <Properties form={form} edit={true} propertyTypes={propertyTypes} mode="create" />

        <RentalInformation form={form} edit={true} mode="create" />

        <MetadataNFT form={form} edit={true} mode="create" />

        <UploadFile
          edit={true}
          form={form}
          defaultThumbnail={thumbnail}
          defaultThumbnails={thumbnails}
          onUpload={(data) => {
            setThumbnail(data)
          }}
          onUploadMulti={(data) => {
            setThumbnails(data)
          }}
        />

        <CoTrustedPartners form={form} edit={true} mode="create" />

        <div style={{ textAlign: 'center', paddingBottom: 5 }}>
          <Button style={{ marginRight: 15 }} key="back" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            disabled={
              thumbnail.length === 0 ||
              thumbnails.length === 0 ||
              isSubmitting ||
              form.getFieldsError().some(({ errors }) => errors.length > 0)
            }
            key="submit"
            type="primary"
            htmlType="submit"
            loading={isSubmitting}
          >
            Create
          </Button>
        </div>
      </Form>
    </div>
  )
}

export default CreatePTOV2
